import React, { Fragment } from 'react';
import {
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  Label,
  Spinner,
  Button,
} from 'reactstrap';
import apiResponse from '../../../../services/apiResponse';
import Doughnut from './../Chart/Doughnut';
import CustomSelect from '../../../../helpers/ui/CustomSelect';
import PensionComponent from './PensionComponent';
import BarChart from '../Chart/BarChart';
import Pie from '../Chart/Pie';
import IndexBloc from './../Blocs/IndexBloc';
import moment from 'moment';
import PieTipePegawai from '../Chart/IdentitasPegawai/PieTipePegawai';
import PieJenisKelaminPegawai from '../Chart/IdentitasPegawai/PieJenisKelaminPegawai';
import PieAgamaPegawai from '../Chart/IdentitasPegawai/PieAgamaPegawai';
import PiePernikahanPegawai from '../Chart/IdentitasPegawai/PiePernikahanPegawai';
import PieJenjangPegawai from '../Chart/IdentitasPegawai/PieJenjangPegawai';
import PieMasaKerjaPegawai from '../Chart/IdentitasPegawai/PieMasaKerjaPegawai';
import PieGologanDarahPegawai from '../Chart/IdentitasPegawai/PieGologanDarahPegawai';
import ChartPendidikanPegawai from '../Chart/PendidikanPegawai/ChartPendidikanPegawai';
import ChartRumpunKelulusanPegawai from '../Chart/PendidikanPegawai/ChartRumpunKelulusanPegawai';
import ChartTugasBelajarPegawai from '../Chart/PendidikanPegawai/ChartTugasBelajarPegawai';
import ChartPenghargaanPegawai from '../Chart/PenghargaanPegawai/ChartPenghargaanPegawai';

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj['label'] = data[label];
    newObj['value'] = data[value];

    return newObj;
  });
};
class DevpegawaiComponent extends React.Component {
  indexBloc = new IndexBloc();
  constructor(props) {
    super(props);
    this.state = {
      optionStatusPegawai: [
        { value: 'PNS', label: 'PNS' },
        { value: 'HONORER', label: 'HONORER' },
        { value: 'KEMENTERIAN', label: 'KEMENTERIAN LEMBAGA' },
      ],

      //FILTER
      selectedStatusPegawai: [],
      startDate: moment().format('YYYY-MM-DD'),
      selectedUnit: [],
      optionUnits: [],

      //DATA
      employees: [],
      Ages: [],
      employeeStatus: [],
      jabatan: [],
      positionGradeGroup: [],
      pensiunList: [],
      rank: [],
      pensiunDoneList: [],
      employeeType: [],
      employeeGender: [],
      employeeReligion: [],
      employeeMarital: [],
      employeeBlood: [],
      yearService: [],
      educationGroup: [],
      studyAssignment: [],
      graduationClump: [],
      award: [],

      // export
      exportAge: null,
      exportStatusPegawai: null,
      exportJenjangJabatan: null,
      exportPositionGrade: null,
      exportPensiun: null,
      exportRank: null,
      exportPensiunDone: null,
      exportEmployeeType: null,
      exportGender: null,
      exportAgama: null,
      exportMarital: null,
      exportBlood: null,
      exportService: null,
      exportEducation: null,
      exportAssigment: null,
      exportRumpun: null,
      exportAward: null,

      // loading state
      loadingEmployees: null,
      loadingAges: null,
      loadingEmployeeStatus: null,
      loadingJabatan: null,
      loadingPositionGradeGroup: null,
      loadingPensiunList: null,
      loadingRank: null,
      loadingPensiunDoneList: null,
      loadingEmployeeType: null,
      loadingGender: null,
      loadingReligion: null,
      loadingMarital: null,
      loadingBlood: null,
      loadingYearService: null,
      loadingEducationGroup: null,
      loadingStudyAssignment: null,
      loadingGraduationClump: null,
      loadingAward: null,

      // link backend
      linkBackend:
        process.env.REACT_APP_SERVICE_CORE_URL === 'http://localhost:801/'
          ? process.env.REACT_APP_SERVICE_CORE_URL
          : process.env.REACT_APP_SERVICE_CORE_URL + '/',
    };
  }

  loadData = () => {
    let query = {
      start_date: this.state.startDate,
      work_unit: this.state.selectedUnit,
      status_pegawai: this.state.selectedStatusPegawai,
    };

    this.setState({
      loadingEmployees: true,
      loadingAges: true,
      loadingEmployeeStatus: true,
      loadingJabatan: true,
      loadingPositionGradeGroup: true,
      loadingPensiunList: true,
      loadingRank: true,
      loadingPensiunDoneList: true,
      loadingEmployeeType: true,
      loadingGender: true,
      loadingReligion: true,
      loadingMarital: true,
      loadingBlood: true,
      loadingYearService: true,
      loadingEducationGroup: true,
      loadingStudyAssignment: true,
      loadingGraduationClump: true,
      loadingAward: true,
    });

    //FILTER
    this.indexBloc.fetchWorkUnit();

    //DATA
    this.indexBloc.fetchEmployees(query);
    this.indexBloc.fetchAges(query);
    this.indexBloc.fetchEmployeeStatus(query);
    this.indexBloc.fetchJabatan(query);
    this.indexBloc.fetchPositionGrade(query);
    this.indexBloc.fetchPensiunList(query);
    this.indexBloc.fetchRank(query);
    this.indexBloc.fetchPensiunDoneList(query);
    this.indexBloc.fetchEmployeeType(query);
    this.indexBloc.fetchGender(query);
    this.indexBloc.fetchReligion(query);
    this.indexBloc.fetchMarital(query);
    this.indexBloc.fetchBlood(query);
    this.indexBloc.fetchYearService(query);
    this.indexBloc.fetchEducation(query);
    this.indexBloc.fetchStudyAssignment(query);
    this.indexBloc.fetchGraduationClump(query);
    this.indexBloc.fetchAward(query);
  };

  componentDidMount() {
    //FILTER
    this.indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              optionUnits: reformatOptions(
                response,
                'work_unit_name_tabs',
                'work_unit_name'
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    //DATA
    this.indexBloc.employeesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            employees: response,
            loadingEmployees: false,
            timeServer: moment
              .unix(result.data.serverTime)
              .format('DD/MM/YYYY'),
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.agesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            Ages: response.group,
            exportAge: response.export.file_url,
            loadingAges: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.employeeStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            employeeStatus: response.group,
            exportStatusPegawai: response.export.file_url,
            loadingEmployeeStatus: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.jabatanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            jabatan: response,
            exportJenjangJabatan: response.export.file_url,
            loadingJabatan: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.positionGradeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            positionGradeGroup: response.group,
            exportPositionGrade: response.export.file_url,
            loadingPositionGradeGroup: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.pensiunListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            pensiunList: response.result,
            exportPensiun: response.export.file_url,
            loadingPensiunList: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let data = result.data.response;

          if (data.rank.length > 0) {
            this.setState({
              exportRank: data.export.file_url,
              loadingRank: false,
              rank: data.rank.filter((item) => item.value > 0),
            });
          }
          break;
        default:
          break;
      }
    });

    this.indexBloc.pensiunDoneListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            pensiunDoneList: response.result,
            exportPensiunDone: response.export.file_url,
            loadingPensiunDoneList: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.employeeTypeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            employeeType: response.group,
            exportEmployeeType: response.export.file_url,
            loadingEmployeeType: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.genderChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            employeeGender: response.gender,
            exportGender: response.export.file_url,
            loadingGender: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.employeeReligionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            employeeReligion: response.agama,
            exportAgama: response.export.file_url,
            loadingReligion: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.employeeMaritalChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            employeeMarital: response.marital,
            exportMarital: response.export.file_url,
            loadingMarital: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.employeeBloodChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            employeeBlood: response.blood,
            exportBlood: response.export.file_url,
            loadingBlood: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.yearServiceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            yearService: response.service,
            exportService: response.export.file_url,
            loadingYearService: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.educationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let data = result.data.response.group;
          let res = result.data.response;
          if (data.length > 0) {
            this.setState({
              educationGroup: data.filter((item) => item.value > 0),
              exportEducation: res.export.file_url,
            });
          }
          this.setState({
            loadingEducationGroup: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.studyAssignmentChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            studyAssignment: response.belajar,
            exportAssigment: response.export.file_url,
            loadingStudyAssignment: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.graduationClumpChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            graduationClump: response.graduation,
            exportRumpun: response.export.file_url,
            loadingGraduationClump: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.awardChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          this.setState({
            award: response.award,
            exportAward: response.export.file_url,
            loadingAward: false,
          });
          break;
        default:
          break;
      }
    });

    this.loadData();
  }

  componentWillUnmount() {
    this.indexBloc.employeesChannel?.unsubscribe();
    this.indexBloc.agesChannel?.unsubscribe();
    this.indexBloc.employeeStatusChannel?.unsubscribe();
    this.indexBloc.jabatanChannel?.unsubscribe();
    this.indexBloc.positionGradeChannel?.unsubscribe();
    this.indexBloc.pensiunListChannel?.unsubscribe();
    this.indexBloc.rankChannel?.unsubscribe();
    this.indexBloc.pensiunDoneListChannel?.unsubscribe();
    this.indexBloc.employeeTypeChannel?.unsubscribe();
    this.indexBloc.genderChannel?.unsubscribe();
    this.indexBloc.employeeReligionChannel?.unsubscribe();
    this.indexBloc.employeeMaritalChannel?.unsubscribe();
    this.indexBloc.employeeBloodChannel?.unsubscribe();
    this.indexBloc.yearServiceChannel?.unsubscribe();
    this.indexBloc.educationChannel?.unsubscribe();
    this.indexBloc.studyAssignmentChannel?.unsubscribe();
    this.indexBloc.graduationClumpChannel?.unsubscribe();
    this.indexBloc.awardChannel?.unsubscribe();
  }

  colorPieAges = [
    '#02a499',
    '#f8b425',
    '#ec4561',
    '#38a4f8',
    '#3c4ccf',
    '#e18743',
  ];

  render() {
    return (
      <Fragment>
        {/* CARD FILTER */}
        <Row>
          <Col md={12}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle style={{ marginBottom: '10px' }}>
                  <h5 style={{ fontWeight: 'bold' }}>Filter : </h5>
                </CardTitle>

                <Row className="mb-3">
                  <Label className="col-md-2 col-form-label">Unit Kerja</Label>
                  <Col md="10">
                    <CustomSelect
                      isAvForm={false}
                      options={this.state.optionUnits}
                      name="unit_kerja"
                      placeholder="Unit Kerja"
                      onChange={(v) => {
                        this.setState({
                          selectedUnit: v != null ? v.value : '',
                        });
                        setTimeout(() => {
                          this.loadData();
                        }, 500);
                      }}
                      isClearable={true}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Label className="col-md-2 col-form-label">
                    Status Pegawai
                  </Label>
                  <Col md="10">
                    <CustomSelect
                      isAvForm={false}
                      options={this.state.optionStatusPegawai}
                      name="status_pegawai"
                      placeholder="Status Pegawai"
                      onChange={(v) => {
                        this.setState({
                          selectedStatusPegawai: v != null ? v.value : '',
                        });
                        setTimeout(() => {
                          this.loadData();
                        }, 500);
                      }}
                      isClearable={true}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* BADGE */}
        <Row>
          <Col md={12} style={{ marginBottom: '10px' }}>
            <h5 style={{ fontWeight: 'bold' }}>Informasi Data Pegawai </h5>
          </Col>
        </Row>

        {/* CARD INFORMASI TOTAL */}
        <Row style={{ marginBottom: '15px' }}>
          <Col md={6} xl={2}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                {console.log('emp', this.state.employees)}
                {this.state.loadingEmployees === false ? (
                  <div>
                    <h4 className="mb-1 mt-1">
                      <span style={{ fontSize: '22px' }}>
                        {this.state.employees != null
                          ? this.state.employees?.total
                          : '-'}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">{'Total Pegawai'}</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col md={6} xl={2}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                {this.state.loadingEmployees === false ? (
                  <div>
                    <h4 className="mb-1 mt-1">
                      <span style={{ fontSize: '22px' }}>
                        {this.state.employees != null
                          ? this.state.employees?.male
                          : '-'}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">{'Laki-laki'}</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col md={6} xl={2}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                {this.state.loadingEmployees === false ? (
                  <div>
                    <h4 className="mb-1 mt-1">
                      <span style={{ fontSize: '22px' }}>
                        {this.state.employees != null
                          ? this.state.employees?.female
                          : '-'}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">{'Perempuan'}</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col md={6} xl={2}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                {this.state.loadingEmployees === false ? (
                  <div>
                    <h4 className="mb-1 mt-1">
                      <span style={{ fontSize: '22px' }}>
                        {this.state.employees != null
                          ? this.state.employees?.struktural
                          : '-'}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">{'Struktural'}</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col md={6} xl={2}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                {this.state.loadingEmployees === false ? (
                  <div>
                    <h4 className="mb-1 mt-1">
                      <span style={{ fontSize: '22px' }}>
                        {this.state.employees != null
                          ? this.state.employees?.fungsional
                          : '-'}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">{'Fungsional'}</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col md={6} xl={2}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                {this.state.loadingEmployees === false ? (
                  <div>
                    <h4 className="mb-1 mt-1">
                      <span style={{ fontSize: '22px' }}>
                        {this.state.startDate}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">Periode</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* INFORMASI DATA PEGAWAI */}
        <Row>
          {/* GRAPH USIA PEGAWAI */}
          <Col md="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Daftar Pegawai Berdasarkan Usia</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingAges === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend + this.state.exportAge
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingAges === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <Pie
                      options={this.state.Ages}
                      colors={this.colorPieAges}
                      margin={['60%', '60%']}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH STATUS PEGAWAI */}
          <Col md="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Daftar Pegawai Berdasarkan Status Pegawai</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingEmployeeStatus === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend +
                                this.state.exportStatusPegawai
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingEmployeeStatus === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <Doughnut options={this.state.employeeStatus} />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH KELAS JABATAN */}
          <Col md="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Daftar Pegawai Berdasarkan Kelas Jabatan</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingPositionGradeGroup === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend +
                                this.state.exportPositionGrade
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingPositionGradeGroup === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <Doughnut options={this.state.positionGradeGroup} />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH JENJANG JABATAN */}
          <Col md="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Daftar Pegawai Berdasarkan Jenjang Jabatan</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingJabatan === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend +
                                this.state.exportJenjangJabatan
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingJabatan === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <PieJenjangPegawai
                      options={this.state.jabatan.struktural}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH PEGAWAI YANG AKAN PENSIUN */}
          <Col md="4">
            <PensionComponent
              options={this.state.pensiunList}
              loading={this.state.loadingPensiunList}
              linkdata={this.state.linkBackend}
              dataexport={this.state.exportPensiun}
              title="Daftar Pegawai yang Akan Pensiun Tahun Ini"
            />
          </Col>

          {/* GRAPH PEGAWAI YANG SUDAH PENSIUN */}
          {/* <Col md="4">
            <PensionComponent
              options={this.state.pensiunDoneList}
              loading={this.state.loadingPensiunDoneList}
              linkdata={this.state.linkBackend}
              dataexport={this.state.exportPensiunDone}
              title="Daftar Pegawai yang Sudah Pensiun"
            />
          </Col> */}

          {/* GRAPH GOLONGAN/RUANG */}
          <Col md="12">
            <Card
              style={{
                height: '380px',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Daftar Pegawai Berdasarkan Golongan/Ruang</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingRank === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend + this.state.exportRank
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingRank === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <BarChart
                      options={this.state.rank}
                      title="Pegawai Berdasarkan Pangkat/Golongan"
                      height={270}
                      colors={['#38a4f8']}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* BADGE */}
        <Row>
          <Col md={12} style={{ marginBottom: '10px' }}>
            <h5 style={{ fontWeight: 'bold' }}>Informasi Identitas Pegawai </h5>
          </Col>
        </Row>

        {/* INFORMASI IDENTITAS PEGAWAI */}
        <Row>
          {/* GRAPH TIPE PEGAWAI */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Tipe Pegawai</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingEmployeeType === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend +
                                this.state.exportEmployeeType
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingEmployeeType === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <PieTipePegawai options={this.state.employeeType} />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH JENIS KELAMIN */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Jenis Kelamin</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingGender === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend + this.state.exportGender
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingGender === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <PieJenisKelaminPegawai
                      options={this.state.employeeGender}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH AGAMA */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="6">Agama</Col>
                    <Col lg="6" className="float-right">
                      {this.state.loadingReligion === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend + this.state.exportAgama
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingReligion === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <PieAgamaPegawai options={this.state.employeeReligion} />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH MARITAL */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Pernikahan</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingMarital === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend +
                                this.state.exportMarital
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingMarital === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <PiePernikahanPegawai
                      options={this.state.employeeMarital}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH GOLONGAN DARAH */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Golongan Darah</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingBlood === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend + this.state.exportBlood
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingBlood === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <PieGologanDarahPegawai
                      options={this.state.employeeBlood}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH MASA KERJA */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <CardTitle>
                    <Row>
                      <Col lg="9">Masa Kerja</Col>
                      <Col lg="3" className="float-right">
                        {this.state.loadingYearService === false ? (
                          <div className="text-end">
                            <Button
                              className="btn btn-success btn-sm float-right"
                              value="jenis_kelamin"
                            >
                              <a
                                href={
                                  this.state.linkBackend +
                                  this.state.exportService
                                }
                                rel="noopener noreferrer"
                                target="_blank"
                                style={{ color: 'white' }}
                              >
                                <i className="fa fa-download"></i> export
                              </a>
                            </Button>
                          </div>
                        ) : (
                          ''
                        )}
                      </Col>
                    </Row>
                  </CardTitle>
                </CardTitle>
                {this.state.loadingYearService === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <PieMasaKerjaPegawai options={this.state.yearService} />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* BADGE */}
        <Row>
          <Col md={12} style={{ marginBottom: '10px' }}>
            <h5 style={{ fontWeight: 'bold' }}>
              Informasi Pendidikan Pegawai{' '}
            </h5>
          </Col>
        </Row>

        {/* INFORMASI PENDIDIKAN PEGAWAI */}
        <Row>
          {/* GRAPH PENDIDIKAN TERAKHIR */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Pendidikan Terakhir</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingEducationGroup === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend +
                                this.state.exportEducation
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingEducationGroup === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <ChartPendidikanPegawai
                      options={this.state.educationGroup}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH TUGAS BELAJAR */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Tugas Belajar</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingStudyAssignment === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend +
                                this.state.exportAssigment
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingStudyAssignment === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <ChartRumpunKelulusanPegawai
                      options={this.state.studyAssignment}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* GRAPH RUMPUN PENDIDIKAN */}
          <Col lg="4">
            <Card
              style={{
                height: '93%',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <Row>
                    <Col lg="9">Rumpun Pendidikan</Col>
                    <Col lg="3" className="float-right">
                      {this.state.loadingGraduationClump === false ? (
                        <div className="text-end">
                          <Button
                            className="btn btn-success btn-sm float-right"
                            value="jenis_kelamin"
                          >
                            <a
                              href={
                                this.state.linkBackend + this.state.exportRumpun
                              }
                              rel="noopener noreferrer"
                              target="_blank"
                              style={{ color: 'white' }}
                            >
                              <i className="fa fa-download"></i> export
                            </a>
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </CardTitle>
                {this.state.loadingGraduationClump === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <ChartTugasBelajarPegawai
                      options={this.state.graduationClump}
                    />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* BADGE */}
        <Row>
          <Col md={12} style={{ marginBottom: '10px' }}>
            <h5 style={{ fontWeight: 'bold' }}>
              Informasi Penghargaan Pegawai{' '}
            </h5>
          </Col>
        </Row>

        {/* INFORMASI PENGHARGAAN PEGAWAI */}
        <Row>
          {/* GRAPH PENGHARGAAN */}
          <Col lg="12">
            <Card
              style={{
                height: '300px',
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>
                  <CardTitle>
                    <Row>
                      <Col lg="9">Penghargaan</Col>
                      <Col lg="3" className="float-right">
                        {this.state.loadingAward === false ? (
                          <div className="text-end">
                            <Button
                              className="btn btn-success btn-sm float-right"
                              value="jenis_kelamin"
                            >
                              <a
                                href={
                                  this.state.linkBackend +
                                  this.state.exportAward
                                }
                                rel="noopener noreferrer"
                                target="_blank"
                                style={{ color: 'white' }}
                              >
                                <i className="fa fa-download"></i> export
                              </a>
                            </Button>
                          </div>
                        ) : (
                          ''
                        )}
                      </Col>
                    </Row>
                  </CardTitle>
                </CardTitle>
                {this.state.loadingAward === false ? (
                  <div id="doughnut-chart" className="e-chart">
                    <ChartPenghargaanPegawai options={this.state.award} />
                  </div>
                ) : (
                  <div className="text-center" style={{ marginTop: '105px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Fragment>
    );
  }
}
export default DevpegawaiComponent;
